import { useState, useEffect, useRef, memo } from 'react';
import * as S from './DeadlineTimer.styled';

type Props = {
    deadline: number;
    onTimeLeft?: (time: number) => void;
};

const getTimeNow = () => {
    return new Date().getTime();
};

const DeadlineTimer = memo(({ deadline, onTimeLeft }: Props) => {
    const [now, setNow] = useState<number>(getTimeNow());
    const [iteration, setIteration] = useState<number>(0);
    const [currentTimeValue, setCurrentTimeValue] = useState<string>('');
    const timerIdRef = useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
        return () => {
            if (timerIdRef.current) clearInterval(timerIdRef.current);
        };
    }, []);

    useEffect(() => {
        const maxIterationBeforeUpdateCurrentTime = 60;
        if (iteration === maxIterationBeforeUpdateCurrentTime) {
            const currentTime = getTimeNow();
            setNow(currentTime);
            setIteration(0);
        }
    }, [iteration]);

    useEffect(() => {
        timerIdRef.current = setInterval(() => {
            setNow((time) => time + 1000);
            setIteration((iteration) => iteration + 1);
        }, 1000);
    }, []);

    useEffect(() => {
        const duration = msToTime(deadline - now);
        setCurrentTimeValue(duration);

        if (onTimeLeft) onTimeLeft(deadline - now);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [now]);

    const msToTime = (duration: number) => {
        if (duration < 0) return '';
        const seconds: number | string = Math.floor((duration / 1000) % 60);
        const minutes: number | string = Math.floor((duration / (1000 * 60)) % 60);
        const hours: number | string = Math.floor((duration / (1000 * 60 * 60)) % 24);
        const days: number = Math.floor(duration / (1000 * 60 * 60 * 24));

        const outputDays = days === 0 ? '' : days === 1 ? days + ' day' : days + ' days';
        const outputHours = hours < 10 ? '0' + hours : hours;
        const outputMinutes = minutes < 10 ? '0' + minutes : minutes;
        const outputSeconds = seconds < 10 ? '0' + Math.trunc(seconds) : Math.trunc(seconds);

        return outputDays + ' ' + outputHours + ':' + outputMinutes + ':' + outputSeconds;
    };

    return <S.Timer timer={deadline - now}>{currentTimeValue}</S.Timer>;
});

export default DeadlineTimer;
